module.exports = __webpack_public_path__ + "static/torch-6148673f25ad7df8a4cb818f97be6cf0.jpg";